module.exports = __webpack_public_path__ + "img/2003-09_the-new-york-times.5786b457.jpg";